export const SnackbarType = {
  CoachingTip: 'CoachingTip',
  Bookmark: 'Bookmark',
  Error: 'Error',
};
